import React from 'react'
import { tv } from 'tailwind-variants'

export interface BadgeProps {
  color?: 'success' | 'secondary' | 'destructive' | 'disable' | 'default' | 'noActive' | 'info'
  size?: 'small' | 'normal' | 'iconNormal' | 'iconSmall'
  border?: 'default' | 'noActive'
  selected?: boolean
  children?: React.ReactNode
  className?: string
  icon?: React.ReactNode
}

let badgeVariants = tv({
  base: 'rounded-2xl inline-flex justify-center items-center cursor-pointer',
  variants: {
    color: {
      default: 'bg-gray-80 ring-gray-80 hover:bg-gray-100 hover:ring-gray-100',
      noActive: 'bg-gray-80 ring-gray-80 hover:bg-gray-300 hover:ring-gray-300',
      success: 'bg-primary-success ring-primary-success hover:bg-lime-900 hover:ring-lime-900',
      secondary: 'bg-primary-info ring-primary-info hover:bg-blue-900 hover:ring-blue-900',
      destructive: 'bg-primary-error ring-primary-error hover:bg-red-900 hover:ring-red-900',
      disable: 'bg-gray-30 ring-gray-400 cursor-not-allowed',
      info: 'bg-primary-info ring-primary-info hover:bg-blue-900 hover:ring-blue-900',
    },
    border: {
      default: 'transparent',
      noActive: 'border border-solid border-zinc-600 rounded-2xl bg-transparent',
    },
    selected: {
      true: 'ring-2 ring-offset-2',
    },
    size: {
      iconSmall: 'min-w-[26px] min-h-[26px] h-6 px-1 py-1 text-xs',
      iconNormal: 'min-w-8 h-8 px-2 text-sm',
      small: 'min-w-fit h-6 pr-2 pl-2 text-xs justify-around',
      normal: 'min-w-20 h-8 pr-5 pl-4 text-sm justify-around',
    },
  },
  defaultVariants: {
    size: 'normal',
    color: 'default',
    border: 'default',
  },
})

export default function Badge(props: BadgeProps) {
  return (
    <div className={badgeVariants(props)}>
      {props.icon && <span>{props.icon}</span>}
      {props.children && <span className="text-white font-medium">{props.children}</span>}
    </div>
  )
}
